import { z } from 'zod';

export const organizationIdOptional = z.object({
    organizationId: z.string().min(1).optional(),
});

export const electricalProjectVersionIdRequired = z.object({
    organizationId: z.string().min(1).optional(),
    electricalProjectVersionId: z.string().min(1),
});

export const electricalProjectDistributionBoardIdRequired = z.object({
    organizationId: z.string().min(1).optional(),
    electricalProjectVersionId: z.string().min(1),
    electricalProjectDistributionBoardId: z.string().min(1),
});

export const electricalProjectDistributionBoardDeviceIdRequired = z.object({
    organizationId: z.string().min(1).optional(),
    electricalProjectVersionId: z.string().min(1),
    electricalProjectDistributionBoardDeviceId: z.string().min(1),
});

export const electricalProjectFinalCircuitIdRequired = z.object({
    organizationId: z.string().min(1).optional(),
    electricalProjectVersionId: z.string().min(1),
    electricalProjectFinalCircuitId: z.string().min(1),
});

export const anyElectricalProjectIdRequired = z.union([
    electricalProjectVersionIdRequired,
    electricalProjectDistributionBoardIdRequired,
    electricalProjectDistributionBoardDeviceIdRequired,
    electricalProjectFinalCircuitIdRequired,
]);
